import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { WithheldIncomeTax } from '../../../models/withheld-income-tax';

import { WithheldIncomeTaxService } from '../../../services/accounting/withheld-income-tax.service';
import { UserService } from '../../../services/users/user.service';

@Component({
  selector: 'app-withheld-income-tax-index',
  templateUrl: './withheld-income-tax-index.component.html',
  styleUrls: ['./withheld-income-tax-index.component.scss'],
})
export class WithheldIncomeTaxIndexComponent implements OnInit {
  count: number = 0;

  withheldIncomeTaxes: Array<WithheldIncomeTax> = [];

  loading: boolean = true;

  constructor(private withheldIncomeTaxService: WithheldIncomeTaxService, private router: Router, private userService: UserService) {}

  ngOnInit() {
    this.userService.navbarComponent.setTaxesMenu();
    this.loadWithheldIncomeTaxes();
  }

  loadWithheldIncomeTaxes() {
    this.loading = true;
    this.withheldIncomeTaxService
      .index()
      .then((response_json) => {
        this.loading = false;
        this.count = response_json.count;
        this.withheldIncomeTaxes = response_json.withheld_income_taxes;
      })
      .catch(() => {
        this.loading = false;
      });
  }

  openNewWithheldIncomeTax() {
    this.router.navigateByUrl('/withheld_income_taxes/new');
  }
}
